export default __webpack_public_path__ + "static/media/build-icon.86a86760.png";